var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgStarUme = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.9987 17.8453L16.6733 19.2507C17.1933 19.524 17.8027 19.0827 17.7027 18.5027L17.192 15.5253L19.356 13.4187C19.7773 13.008 19.5453 12.292 18.9627 12.208L15.9733 11.7733L14.636 9.06267C14.376 8.53467 13.624 8.53467 13.3627 9.06267L12.0267 11.7733L9.03733 12.208C8.45467 12.292 8.22267 13.008 8.644 13.4187L10.808 15.5253L10.2973 18.5027C10.1973 19.0827 10.8067 19.524 11.3267 19.2507L14.0013 17.8453H13.9987V17.8453Z",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6667 14H25.2",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.8 14H1.33333",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1467 4.85333L21.7467 6.25333",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.88 23.1867L6.29333 21.7733",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.85333 4.88L6.25333 6.29333",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1867 23.1467L21.7733 21.7467",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M14 25.2533V26.6667",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M14 1.33333V2.74667",
  stroke: "#F9D100",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarUme, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star-ume.37156895.svg";
export { ForwardRef as ReactComponent };